// extracted by mini-css-extract-plugin
export var inline = "SocialShare-module--inline--6Dxhc";
export var socialsLabel = "SocialShare-module--socialsLabel--HwjWn";